import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { OrderOverviewList } from "@/components/admin/OrderOverviewList";

const AdminOrderOverviewPage = () => {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <main className="flex-1 overflow-auto">
          <div className="container mx-auto py-6 space-y-6">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">ข้อมูลซื้อคอร์ส</h1>
              <p className="text-muted-foreground">
                จัดการและดูข้อมูลคำสั่งซื้อคอร์สทั้งหมด
              </p>
            </div>
            <OrderOverviewList />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default AdminOrderOverviewPage;
